import { Box, Typography, Grid, Chip, Card, CardContent } from '@mui/material';
import { useVendorContext } from '../context/VendorContextProvider';

const Dashboard = () => {
  const { currentVendor, loading } = useVendorContext();

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <Typography variant="h6">Loading vendor data...</Typography>
      </Box>
    );
  }

  if (!currentVendor) {
    return (
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <Typography variant="h6">No vendor company selected</Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          Please select a vendor company from the menu.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, mb: 8 }}>
      <Card sx={{ 
        mb: 4, 
        overflow: 'hidden', 
        borderRadius: '16px',
        border: '1px solid rgba(16, 29, 59, 0.2)',
        boxShadow: '0px 8px 32px -4px rgba(16, 29, 59, 0.1)'
      }}>
        <CardContent sx={{ p: 0 }}>
          <Box 
            sx={{ 
              bgcolor: '#00AB9B', 
              py: 2, 
              px: 3 
            }}
          >
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700, 
                color: '#FFFFFF !important',
                fontSize: '18px'
              }}
            >
              Vendor Information
            </Typography>
          </Box>
          <Box sx={{ p: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Address:</Box> 
                  {currentVendor.address}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>City:</Box> 
                  {currentVendor.city}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>State:</Box> 
                  {currentVendor.state}
                </Typography>
                <Typography variant="body1" sx={{ color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Zip Code:</Box> 
                  {currentVendor.zipCode}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Contact:</Box> 
                  {currentVendor.contactFullName}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Email:</Box> 
                  {currentVendor.contactEmail}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Phone:</Box> 
                  {currentVendor.contactPhoneNumber}
                </Typography>
                <Box sx={{ color: '#101D3B' }}>
                  <Box component="span" sx={{ fontWeight: 700, mr: 1 }}>Status:</Box>
                  <Chip 
                    label={currentVendor.status.charAt(0).toUpperCase() + currentVendor.status.slice(1)} 
                    size="small" 
                    sx={{ 
                      ml: 1, 
                      fontWeight: 500,
                      height: '24px',
                      display: 'inline-flex',
                      position: 'relative',
                      top: '-1px',
                      bgcolor: currentVendor.status === 'active' ? 'rgba(0, 171, 155, 0.1)' : 'rgba(16, 29, 59, 0.1)',
                      color: currentVendor.status === 'active' ? '#00AB9B' : 'rgba(16, 29, 59, 0.6)',
                      border: '1px solid',
                      borderColor: currentVendor.status === 'active' ? '#00AB9B' : 'rgba(16, 29, 59, 0.2)',
                      '& .MuiChip-label': {
                        color: currentVendor.status === 'active' ? '#00AB9B' : 'rgba(16, 29, 59, 0.6)',
                        padding: '0 8px'
                      }
                    }} 
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      
      <Grid container spacing={3}>
        {/* Add more dashboard content here if needed */}
      </Grid>
    </Box>
  );
};

export default Dashboard; 